<template>
    <div id="edit-announcement-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Edit Announcement</h1>
                <template v-if="loaded">
                    <AnnouncementForm :formData="announcementObject" submitText="Update" @formSubmitted="updateAnnouncement" />
                </template>
            </section>
        </div>
    </div>
</template>

<script>
import AnnouncementForm from "@/components/forms/AnnouncementForm.vue"
const apiBase = process.env.VUE_APP_API_BASE
import axios from "axios"

export default {
    name: 'AnnouncementsEdit',
    components: {AnnouncementForm},
    data: function() {
        return {
            announcementId: this.$route.params.id,
            announcementObject: null,
            loaded: false
        }
    },
    created() {
        axios.get(apiBase + '/announcements/' + this.announcementId)
            .then(response => {
                this.announcementObject = response.data.data
                this.loaded = true
            })
            .catch(error => {
                alert('Could not load announcement!')
                console.log(error)
            })
    },
    methods: {
        updateAnnouncement(data) {
            axios.put(apiBase + '/announcements/' + this.announcementId, data)
                .then(() => {
                    //console.log(response)
                    alert('Announcement updated successfully')
                    this.$router.push('/announcements')
                })
                .catch(error => {
                    alert('Error occurred!')
                    console.log(error)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>